export const parseJwt = (token: string) => {
  try {
    if (!token || typeof token !== 'string') {
      throw new Error('Invalid token. Token must be a non-empty string.');
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error(
        'Invalid token format. Token must have three parts separated by dots.',
      );
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing JWT.');
    return null;
  }
};
